<template>
  <div class="columns is-multiline is-centered">
    <div class="column is-half">
      <b-input rounded icon="search" type="search" v-model="filterText" placeholder="Filter by shipper name"/>
    </div>
    <div class="column is-full">
      <b-table :data="filteredList"
               :loading="isFetching"
               striped
               hoverable>

    <template slot="empty">
      <section class="section" v-show="!isFetching">
        <div class="content has-text-grey has-text-centered">
          <p >There are no shippers pending approval.</p>
        </div>
      </section>
    </template>


    <template slot-scope="props">
      <b-table-column label="" width="250">
        <div class="buttons is-centered">
          <button class="button is-success"
                  :class="{ 'is-loading': listOfLoadings.includes(props.row.companyKey) }"
                  @click="_takeAction('approveShipper', props.row.companyKey)">
            Approve
          </button>

          <button class="button"
                  :class="{ 'is-loading': listOfLoadings.includes(props.row.companyKey) }"
                  @click="_takeAction('rejectShipper', props.row.companyKey)">
            Reject
          </button>
        </div>

      </b-table-column>

      <b-table-column label="Company">
        <router-link :to="{ name: 'shipper-company-profile', params: {companyKey: props.row.companyKey }}">
        {{ props.row.companyName }}
        </router-link>
      </b-table-column>

      <b-table-column field="companyTaxId" label="EIN">
        {{ props.row.companyTaxId }}
      </b-table-column>

      <b-table-column field="companyDunAndBradStreetNumber" label="DUNS">
        {{ props.row.companyDunAndBradStreetNumber }}
      </b-table-column>
    </template>

  </b-table>
    </div>
  </div>
</template>

<script>
// TODO: this is 90% similar to FactoringApprovalsCarrierTable.vue and should be made more generic

import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'FactoringApprovalsShipperTable',

  data() {
    return {
      listOfLoadings: [],
      isFetching: false,
      filterText: ''
    }
  },

  computed: {
    ...mapGetters('factoring', { shippers: 'pendingApprovalShippers' }),
    filteredList() {
      return this.shippers.filter((shipper) => shipper.companyName.toLowerCase().includes(this.filterText))
    }
  },

  async created() {
    if (this.shippers.length === 0) {
      this.isFetching = true
      try {
        await this.fetchPendingApprovals()
      } catch (error) {
        console.error(`Error fetching shipper approval list`, error)
      } finally {
        this.isFetching = false
      }
    }
  },

  methods: {
    ...mapActions('factoring', ['fetchPendingApprovals', 'approveShipper', 'rejectShipper']),
    async _takeAction(actionName, key) {
      this.listOfLoadings.push(key)
      try {
        await this[actionName](key)
      } catch (error) {
        console.error(`Error acting on factoring`, error)
      } finally {
        const targetIndex = this.listOfLoadings.indexOf(key)
        this.listOfLoadings.splice(targetIndex, 1)
      }
    }
  }
}
</script>

<style scoped>
</style>
